export default __webpack_public_path__ + "static/insta-hotels-10-9dd5633ddceb7ff47dc32612aceaa31c.jpg";